import { ApolloError } from "@apollo/client";
import {
  EntityReference,
  EnumEntityReferenceType,
  Multilingual,
  NoteManyQuery,
} from "gql/generated";
import { createContext } from "react";
import { SuggestionDataItem } from "react-mentions";

export type NoteCreateUpdateProps = {
  message: string;
  mentions?: string[];
  entity?: Omit<EntityReference, "__typename">;
  noteDateISO?: string;
};

export type LinkedToEntity = {
  entityId: string;
  entityType: EnumEntityReferenceType;
  name: Multilingual;
};

export type NotesContextValues = {
  defaultNoteEntity: Omit<EntityReference, "__typename"> | null;
  defaultNoteEntityName: Multilingual | null;
  allowArchiving: boolean;
  allowDeleting: boolean;
  hideDisplayDate: boolean;
  notes: NoteManyQuery["noteMany"];
  hasMore: boolean;
  initialLoad: boolean;
  error: ApolloError | undefined;
  loading: boolean;
  isSavingNote: boolean;
  mentionableUsers: SuggestionDataItem[];
  createNote: (note: NoteCreateUpdateProps) => Promise<boolean>;
  updateNote: (noteId: string, note: NoteCreateUpdateProps) => Promise<boolean>;
  archiveNote: (noteId: string, isArchived: boolean) => Promise<boolean>;
  deleteNote: (noteId: string) => Promise<boolean>;
  linkedToEntities: LinkedToEntity[];
  loadingLinkedToEntities: boolean;
  viewOnly: boolean;
};

export const NotesContext = createContext<NotesContextValues | null>(null);
